module.exports = __webpack_public_path__ + "img/chadle_adv_08.7d72c13c.png";